<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select v-model="formData.type" placeholder="选择类型" filterable>
          <el-option label="选择类型" :value="0"></el-option>
          <el-option v-for="item in typeList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="addConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'special_category_add',
  props: [
    'visible', 'id', 'typeList'
  ],
  data () {
    return {
      title: '添加主题封面',
      formData: {
        title: '',
        type: 1
      },
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      if (this.id > 0) {
        this.title = '编辑主题封面'
        this.getInfo(this.id)
      } else {
        this.title = '添加主题封面'
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/special_category/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title || '',
          type: Number(res.data.type) || 0
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
